module.exports = __webpack_public_path__ + "static/media/wheel-locks.552e4c11.svg";